import { getPaymentImplementation } from '../Payments/providers.js';
import { isValidPaymentMethod } from './is-valid-payment-method.js';

const isStepValid = (selectedPaymentMethod, selectedPaymentDetails, stepPaymentState)=>{
    if (!selectedPaymentMethod || !isValidPaymentMethod(selectedPaymentMethod, stepPaymentState)) {
        return false;
    }
    const paymentImplementation = getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
    if (!paymentImplementation) {
        return false;
    }
    if (!paymentImplementation.form) {
        // If payment type does not have a form we assume it's valid upon selecting it
        return true;
    }
    if (!selectedPaymentDetails) {
        // If payment type has a form but no details have been filled in yet
        return false;
    }
    return selectedPaymentDetails.isValid;
};

export { isStepValid };
//# sourceMappingURL=is-step-valid.js.map
